import { generatedCardGroup } from '../../branding'
import './GeneratedOriginBadge.css'

interface GeneratedOriginBadgeProps {
  /** The group's `badgeText`; empty renders nothing. */
  text: string
  origin: string | undefined
}

export function GeneratedOriginBadge({ text, origin }: GeneratedOriginBadgeProps) {
  const group = generatedCardGroup(origin)
  if (!text || !group) return null
  return (
    <span className="feed-card-origin-badge" data-origin-group={group}>
      {text}
    </span>
  )
}
